import System from '../System';
import Game from '../../Game';
import Timer from './Timers/Timer';
import { IGameState } from '../../State/Game/IGameState';
import { report } from '../../report';

export default class TimerSystem extends System {
    private static instance: TimerSystem;

    private timers = new Array<Timer>();
    private interval: null | (() => void) = null;

    public init(): void {
        if (TimerSystem.instance) {
            report('You can only have one timer system in a scene', {
                once: true,
            });
        }
        TimerSystem.instance = this;
    }

    public onStart(): void {}

    public handleStateChanged(state: IGameState) {}

    public onDestroy() {
        Game.ticker.clearInterval(this.interval);
        this.interval = null;
        TimerSystem.instance = null;
    }

    public preload(): Promise<any> {
        return undefined;
    }
    public onUpdate() {}
    public onLateUpdate() {}
    public onStop() {}

    public static addTimer(timer: Timer): null | (() => void) {
        const system = this.instance;
        if (!system) {
            report(
                'You must add a timer system to the scene before you add a timer.',
                { once: true }
            );
            return null;
        }

        system.timers.push(timer);

        if (!system.interval) {
            system.interval = Game.ticker.setInterval(
                system.timerTick.bind(system),
                1000
            );
        }
        system.onUpdate();

        const removeTimer = () => {
            system.timers = system.timers.filter(t => t !== timer);

            if (system.timers.length === 0 && system.interval) {
                Game.ticker.clearInterval(system.interval);
                system.interval = null;
            }

            if (system === this.instance) {
                system.onUpdate();
            }
        };

        return removeTimer;
    }
    public timerTick(): void {
        const state = Game.store.getState();
        if (state.gamePaused) return;

        this.timers.forEach(timer => {
            this.updateTimer(timer, state);
        });
    }

    public updateTimer(timer: Timer, state: IGameState): void {
        if (timer.getDate(state) === null && !timer.canContinue()) {
            timer.onUpdate(state);
            timer.update(state);
            return;
        }

        if (timer.isCompleted(state)) {
            timer.complete(state);
        }

        timer.onUpdate(state);
    }
}
